import { render } from "./Noticias.vue?vue&type=template&id=9ca419f2&scoped=true"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"

import "./Noticias.vue?vue&type=style&index=0&id=9ca419f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca419f2"]])

export default __exports__